var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade show",
      staticStyle: { display: "block" },
      attrs: {
        id: "go-modal-pin-limit",
        tabindex: "-1",
        "aria-hidden": "true",
      },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.closeShareTopic.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog go-modal-prompt",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.doNothing.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("report.share"))),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.closeShareTopic.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "go-share-sns" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.methodInsert(_vm.shareOnTwitter)
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-text" }, [_vm._v("Twitter")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.methodInsert(_vm.shareOnFacebook)
                      },
                    },
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-text" }, [
                      _vm._v("Facebook"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.methodInsert(_vm.shareOnLinkedIn)
                      },
                    },
                  },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-text" }, [
                      _vm._v("Linkedin"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-share-link" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shareTopicURL,
                      expression: "shareTopicURL",
                    },
                  ],
                  staticClass: "go-form-control",
                  attrs: { rows: "2", readonly: "" },
                  domProps: { value: _vm.shareTopicURL },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.shareTopicURL = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: { type: "button", disabled: _vm.isCopied },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.methodInsert(_vm.copyLink)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.isCopied
                            ? _vm.$t("ask.copied")
                            : _vm.$t("report.copyLink")
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "go-sns-brand go-sns-brand-lg go-sns-brand-twitter-x" },
      [_c("i", { staticClass: "go-icon-32 go-icon-brand-twitter-x" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "go-sns-brand go-sns-brand-lg go-sns-brand-facebook" },
      [_c("i", { staticClass: "go-icon-32 go-icon-brand-facebook" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "go-sns-brand go-sns-brand-lg go-sns-brand-linkedin" },
      [_c("i", { staticClass: "go-icon-32 go-icon-brand-linkedin" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }